// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'babel-polyfill'
import { Carousel,CarouselItem,Tabs,TabPane,Popover,Dialog,Button,ButtonGroup,Message,Pagination } from 'element-ui';
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import util from '@/util/util.js'
import { preloadAllAtsHeroImages, preloadAtsBrandLogo, preloadAtsPageByPath } from '@/util/atsImagePreload'

Vue.prototype.util = util
Vue.config.productionTip = false
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Popover);
Vue.use(Dialog);
Vue.use(Button);
Vue.use(ButtonGroup);
Vue.use(Pagination);
// Vue.component(Message.name, Message);
/* eslint-disable no-new */
Vue.prototype.$message = Message;

preloadAtsBrandLogo()
preloadAllAtsHeroImages()

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.hideLayout) {
    preloadAtsPageByPath(to.path).finally(() => next())
    return
  }
  next()
})

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  data: {
    // 空的实例放到根组件下，所有的子组件都能调用
    bus: new Vue()
  }
})



// WEBPACK FOOTER //
// ./src/main.js